import React, { useState, useEffect, useContext } from "react"
import request from "request"

import { ApplicationContext } from "ApplicationContext"
import Header from "Header"
import Table from "Table"
import AsyncContainer from "AsyncContainer"
import Button from "Button"
import Icon from "Icon"
import CreateAPIKeyModal from "./CreateAPIKeyModal"

const APIKeysList = () => {
  const { CurrentUserContext } = useContext(ApplicationContext)
  const { venue: currentVenue } = CurrentUserContext
  const [isLoaded, setIsLoaded] = useState(false)
  const [APIKeys, setAPIKeys] = useState([])
  const [showCreateModal, setShowCreateModal] = useState(false)

  const API_KEY_HEADERS = {
    identifier: "Identifier",
    name: "Name",
    maskedKey: "API Key",
    lastUsedAt: "Last Used",
    createdAt: "Created",
    active: "Status",
    actions: "Actions",
  }

  const API_KEY_FORMATTERS = {
    identifier: (key) => <code className="has-text-weight-bold">{key.identifier}</code>,
    maskedKey: (key) => <code className="is-family-monospace is-size-7">{key.maskedKey}</code>,
    lastUsedAt: (key) => key.lastUsedAt ? new Date(key.lastUsedAt).toLocaleString() : "Never",
    createdAt: (key) => new Date(key.createdAt).toLocaleDateString(),
    active: (key) => (
      <span className={`tag ${key.active ? 'is-success' : 'is-danger'}`}>
        {key.active ? 'Active' : 'Inactive'}
      </span>
    ),
    actions: (key) => key.active && (
      <Button
        text={<Icon icon="trash" />}
        color="danger"
        onClick={() => handleDelete(key.id)}
        size="small"
      />
    ),
  }

  const loadAPIKeys = () => {
    const req = request.get("/venue_admin/api_keys")
    req.then(({ data }) => {
      console.log(data)
      console.log('DATADATADATA')
      setAPIKeys(data.apiKeys || [])
      setIsLoaded(true)
    })
    return req
  }

  const handleDelete = (id) => {
    if (!confirm("Are you sure you want to deactivate this API key? This action cannot be undone and any integrations using this key will stop working.")) {
      return
    }

    request.delete(`/venue_admin/api_keys/${id}`).then(() => {
      request.get("/venue_admin/api_keys").then(({ data }) => {
        setAPIKeys(data.apiKeys || [])
      })
    })
  }

  const handleCreateSuccess = () => {
    setShowCreateModal(false)
    request.get("/venue_admin/api_keys").then(({ data }) => {
      setAPIKeys(data.apiKeys || [])
    })
  }

  useEffect(() => {
    let isMounted = true
    const req = request.get("/venue_admin/api_keys")
    req.then(({ data }) => {
      if (isMounted) {
        setAPIKeys(data.apiKeys || [])
        setIsLoaded(true)
      }
    })
    return () => {
      isMounted = false
    }
  }, [currentVenue])

  return(
    <div>
      <Header text="API Keys" />

      <div className="block">
        <div className="content">
          <p>
            API keys allow external systems to integrate with Catch and create orders programmatically.
            Each API key is scoped to this venue and can be used to access the public API.
          </p>
          <p>
            <strong>Important:</strong> Keep your API keys secure. Anyone with access to an API key can create orders on your behalf.
          </p>
          <p>
            View the API documentation at <a href="/api-docs" target="_blank">/api-docs</a>
          </p>
        </div>
      </div>

      <div className="block">
        <Button
          text="Create New API Key"
          color="primary"
          onClick={() => setShowCreateModal(true)}
          icon="plus"
        />
      </div>

      <div className="block">
        <AsyncContainer isLoaded={isLoaded}>
          {APIKeys.length === 0 ? (
            <div className="notification is-info">
              <p>No API keys created yet. Click "Create New API Key" to get started.</p>
            </div>
          ) : (
            <Table
              rows={APIKeys}
              headers={API_KEY_HEADERS}
              formatters={API_KEY_FORMATTERS}
            />
          )}
        </AsyncContainer>
      </div>

      <CreateAPIKeyModal
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSuccess={handleCreateSuccess}
      />
    </div>
  )
}

export default APIKeysList
